/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import FeelingEvasSectionContent from "core/components/feeling-evas/sliders/component";
import { EmberChangeset } from "ember-changeset";
import { WrFormComponentSignature } from "ember-wiser/components/wr/form";
export default class extends FeelingEvasSectionContent {}